import React, { useEffect} from 'react'
import styles from './List.module.css'
import { useSelector } from 'react-redux'
import Species from './Species'
import Spinner from './Spinner/Spinner'
import { useDispatch } from 'react-redux'

import { getResponses } from '../../../actions/responses'

const List = () => {

    
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(getResponses())
    }, [dispatch])


    const allResponses = useSelector(state => state.responses)


    return (
        !allResponses.length ? <Spinner /> :
        (
        <div className={styles.list}>
            {
                allResponses.map((response) => (
                    <Species 
                        key={response._id}
                        response={response} 
                        
                    />
                ))
            }
        </div>)
    )
}

export default List
